import { render, staticRenderFns } from "./msPaginationViewer.vue?vue&type=template&id=5bcbeb3c&scoped=true"
import script from "./msPaginationViewer.vue?vue&type=script&lang=js"
export * from "./msPaginationViewer.vue?vue&type=script&lang=js"
import style0 from "./msPaginationViewer.vue?vue&type=style&index=0&id=5bcbeb3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbeb3c",
  null
  
)

export default component.exports